// 拓扑视觉编码与常量：供拓扑图、详情面板、以及大模型返回结果的样式化共用。

// 节点分类调色板（按 category 决定填充色）
const palette = {
  drone: { fill: '#FFE7BA', stroke: '#FA8C16' },
  station: { fill: '#BAE7FF', stroke: '#1890FF' },
  satellite: { fill: '#D3ADF7', stroke: '#722ED1' },
  router: { fill: '#B5F5EC', stroke: '#13C2C2' },
  switch: { fill: '#FFD6E7', stroke: '#EB2F96' },
  terminal: { fill: '#D9F7BE', stroke: '#52C41A' },
  gateway: { fill: '#FFADD2', stroke: '#C41D7F' },
  service: { fill: '#BAE7FF', stroke: '#096DD9' },
  storage: { fill: '#FFE58F', stroke: '#D48806' },
  controller: { fill: '#FFA39E', stroke: '#CF1322' },
  sensor: { fill: '#B7EB8F', stroke: '#389E0D' },
  actuator: { fill: '#FFD591', stroke: '#D46B08' }
}

// 状态调色板：供拓扑图（边/节点描边）与详情面板（图例/徽章）共用
export const STATUS_STYLES = {
  normal: { color: '#52C41A', label: '正常' },
  saturated: { color: '#F5222D', label: '饱和/拥塞' },
  degraded: { color: '#FA8C16', label: '退化' },
  down: { color: '#8C8C8C', label: '离线' }
}

// 节点分类 -> G6 内置图形，做到"不同节点不同形状"
const shapeByCategory = {
  station: 'rect',
  switch: 'rect',
  service: 'rect',
  controller: 'rect',
  router: 'circle',
  gateway: 'diamond',
  satellite: 'diamond',
  drone: 'triangle',
  sensor: 'triangle',
  terminal: 'ellipse',
  storage: 'ellipse',
  actuator: 'star'
}

// 供大模型使用的允许取值，保证返回结果能被正确样式化。
export const NODE_CATEGORIES = Object.keys(palette)
export const STATUS_VALUES = Object.keys(STATUS_STYLES)

// 分类 -> G6 形状与填充/描边样式；供节点渲染、新增与编辑复用。
export function styleForCategory(category) {
  const c = palette[category] || { fill: '#5B8FF9', stroke: '#3370FF' }
  return {
    type: shapeByCategory[category] || 'circle',
    style: { fill: c.fill, stroke: c.stroke, lineWidth: 2 }
  }
}

// 为一组节点补齐 status、G6 形状与填充/描边样式。
export function withStyle(nodes) {
  return nodes.map((n) => {
    const visual = styleForCategory(n.category)
    return {
      ...n,
      status: n.status || 'normal',
      type: visual.type,
      style: visual.style
    }
  })
}

export const TOPOLOGY_TYPES = [
  { value: 'drone', label: '无人机网络' },
  { value: 'communication', label: '通信网络' },
  { value: 'microservice', label: '微服务' },
  { value: 'machinery', label: '复杂机械' }
]

export const CATEGORY_LABELS = { router: '路由器', switch: '交换机', station: '基站', satellite: '卫星', drone: '无人机', terminal: '终端与无人车', gateway: '网关', service: '服务节点', storage: '存储设备', controller: '控制器', sensor: '传感器', actuator: '执行器与无人狗', generic: '通用设备' }
